<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="search-bar-wrapper" v-bind:style="{height: ((height / ($mq === 'sm' ? 8 : 10)) + 'rem')}">
    <vue-google-autocomplete
      id="search"
      classname="search-bar"
      placeholder="지역명, 지하철역명, 대학교명을 입력하세요."
      country="kr"
      types=''
      v-model="searchInput"
      ref="searchBar"
      v-on:placechanged="placeChange"
      v-on:inputChange="inputChange"
      @blur="setRankingHide"
      @keypress.enter="setPlaceBySubmit"
    >
    </vue-google-autocomplete>
    <button class="search-btn" @click="setPlaceBySubmit"></button>
  </div>
</template>

<script>
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import { mapActions } from 'vuex'

  export default {
    name: 'SearchBar',
    components: {VueGoogleAutocomplete},
    props: {
      placeChange: {
        type: Function,
        default: () => {}
      },
      height: {
        type: Number,
        default: 60
      }
    },
    data () {
      return {
        searchInput: ''
      }
    },
    methods: {
      inputChange (input) {
        if (this.$mq !== 'sm') {
          if (input.newVal) {
            this.setRankingIsHide(true)
          } else {
            this.setRankingIsHide(false)
          }
        }
      },
      setRankingHide() {
        this.setRankingIsHide(false)
      },
      setPlaceBySubmit () {
        const searchData = this.$refs.searchBar.autocompleteText
        const places = new this.daum.maps.services.Places()

        this.$refs.searchBar.blur()

        const keywordcallback = (result, status) => {
          if (status === this.daum.maps.services.Status.OK) {
            if (result.length > 0) {
              this.placeChange({
                latitude: result[0].y,
                longitude: result[0].x
              })
            }
          }
        }

        places.keywordSearch(searchData, keywordcallback)
      },
      ...mapActions([
        'setRankingIsHide'
      ])
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .search-bar-wrapper {
    width: 100%;
    background: @white;
    position: relative;

    .search-btn {
      position: absolute;
      background: url('../../assets/images/search_btn.png') no-repeat no-repeat center center;
      background-size: 8rem 8rem;
      right: 3rem;
      display: inline-block;
      vertical-align: middle;
      width: 4rem;
      height: 4rem;
      margin: auto;
      top: 0;
      bottom: 0;
    }

    .search-bar {
      text-align: left;
      padding: 0 3rem;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
  }
</style>

<style scoped lang="less" >
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {

    .search-bar-wrapper {

      &:after {
        background-size: 1.65rem;
        right: 1.25rem;
      }
      .search-bar {
        max-width: 90%;
        padding: 0;
      }
    }
  }
</style>
